import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { memberApi } from '@formosa/shared/api/member';
import { setFormatDateTimeSettings } from '@formosa/shared/utils/formatDateTime';
import {
  DEFAULT_TIME_ZONE_CONFIG,
  normalizeTimeZoneConfig,
  pickTimeZoneConfigFromTenantList,
} from '@formosa/shared/utils/timeZoneConfig';

const TimeZoneContext = createContext(null);

export function TimeZoneProvider({ children }) {
  const [ready, setReady] = useState(false);
  const [config, setConfig] = useState(DEFAULT_TIME_ZONE_CONFIG);

  useEffect(() => {
    let active = true;

    memberApi.getTenantConfig()
      .then((list) => {
        if (!active) {
          return;
        }
        const next = pickTimeZoneConfigFromTenantList(list);
        setFormatDateTimeSettings(next);
        setConfig(next);
        setReady(true);
      })
      .catch(() => {
        if (!active) {
          return;
        }
        setFormatDateTimeSettings(DEFAULT_TIME_ZONE_CONFIG);
        setConfig(DEFAULT_TIME_ZONE_CONFIG);
        setReady(true);
      });

    return () => {
      active = false;
    };
  }, []);

  const value = useMemo(() => ({ ready, config }), [ready, config]);

  if (!ready) {
    return <div className="app-bootstrapping" aria-busy="true" />;
  }

  return (
    <TimeZoneContext.Provider value={value}>
      {children}
    </TimeZoneContext.Provider>
  );
}

export function useTimeZoneConfig() {
  const ctx = useContext(TimeZoneContext);
  if (!ctx) {
    return normalizeTimeZoneConfig(DEFAULT_TIME_ZONE_CONFIG);
  }
  return ctx.config;
}
